<div class="section">
  <div class="container">
    @if (loaded()) {
    <div class="section center-box">

      @if (!afterLogin) {
      <div class="image">
        <img class="logo" src="/assets/img/icon_check.png">
      </div>
      <div class="title">
        {{ 'registration_feedback' | translate }}
      </div>
      }

      @if (needsActivation() && afterLogin) {
      <div class="subtitle">
        {{ 'registration_feedback_email_not_activated_after_login' | translate }}
      </div>
      }
      @if (needsActivation() && !afterLogin) {
      <div class="subtitle">
        {{ 'registration_feedback_email_not_activated_after_registration' | translate }}
      </div>
      }

      @if (needsActivation()) {
      <div class="submit">
        <button class="coupon-button" (click)="resendActivationEmail()">{{ 'button_send_again' | translate | uppercase }}</button>
      </div>
      }
      @else {
      <div class="submit">
        <button class="coupon-button" (click)="associate()">{{ 'landing_start_button' | translate | uppercase }}</button>
      </div>
      }
    </div>
    }
  </div>
</div>
